import { jsx as e } from "react/jsx-runtime";
import { c } from "../../../clsx-OuTLNxxd.js";
const _ = "_divider_1shir_29", h = "_dashed_1shir_56", i = {
  divider: _,
  "small-space": "_small-space_1shir_36",
  "with-text": "_with-text_1shir_39",
  dashed: h,
  "divider-text": "_divider-text_1shir_65"
};
function v({ className: d, smallSpace: r, text: s, dashed: a, ...t }) {
  const l = c(
    i.divider,
    r && i["small-space"],
    s && i["with-text"],
    a && i.dashed,
    d
  );
  return /* @__PURE__ */ e("div", { className: l, role: "separator", "aria-label": s || "divider", ...t, children: s && /* @__PURE__ */ e("span", { className: i["divider-text"], children: s }) });
}
export {
  v as Divider
};
